export const getIsMobile = (state) => state.ui.isMobile;